import {
  AddressBookTabs,
  CardsThree,
  ChartBar,
  ChatsCircle,
  ClipboardText,
  LinkedinLogo,
  PaperPlaneTilt,
  Rocket,
} from "@phosphor-icons/react";
import { useState } from "react";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useInboxWsToken from "common/datahooks/useInboxWsToken";
import { getWhitelabelCustomization } from "common/helpers/utils";
import useWebsocket from "common/hooks/useWebSocket";
import type { NavItemType } from "common/types";

import IntegrationsIcon from "assets/icons/integrations.svg?react";

export default function useNavItems() {
  const { subscription_status } = useSelectedWorkspaceContext();

  const { inboxWsToken } = useInboxWsToken();
  useWebsocket<{ type: "unread"; unread_count: number }>(
    inboxWsToken &&
      `${import.meta.env.VITE_INBOX_WS_URL}/unread?authorization=${inboxWsToken}`,
    ({ unread_count }) => {
      setUnreadMessagesCount(unread_count);
    },
  );
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const navItems: NavItemType[] = [
    {
      path: "home",
      label: "Analytics",
      icon: <ChartBar weight="fill" />,
    },
  ];

  if (subscription_status === "in_trial" && !getWhitelabelCustomization()) {
    navItems.unshift({
      path: "onboarding",
      label: "Onboarding",
      icon: <Rocket weight="fill" className="rotate-45" />,
    });
  }

  navItems.push({
    path: "accounts",
    label: "Accounts",
    icon: <LinkedinLogo weight="fill" />,
    visibleForPermissions: ["accounts_limited"],
  });

  navItems.push({
    path: "campaigns",
    label: "Campaigns",
    icon: <PaperPlaneTilt weight="fill" />,
    visibleForPermissions: ["campaigns_limited"],
  });

  // TODO: gate this behind a permission once lists has one
  navItems.push({
    path: "lists",
    label: "Lead Lists",
    icon: <ClipboardText weight="fill" />,
  });

  navItems.push({
    path: "templates",
    label: "Templates",
    icon: <CardsThree weight="fill" />,
    visibleForPermissions: ["templates_limited"],
  });

  navItems.push({
    path: "leads",
    label: "Leads",
    icon: <AddressBookTabs weight="fill" />,
    visibleForPermissions: ["leads_full"],
  });

  navItems.push({
    path: "inbox",
    label: "Inbox",
    icon: <ChatsCircle weight="fill" />,
    visibleForPermissions: ["inbox_limited"],
    notificationsCount: unreadMessagesCount,
  });

  navItems.push({
    path: "integrations",
    label: "Integrations",
    icon: <IntegrationsIcon />,
    visibleForPermissions: ["integrations_full"],
  });

  return navItems;
}
